module.exports = __webpack_public_path__ + "static/media/musician-letter-logo.9d2094d9.jpg";